import { render, staticRenderFns } from "./traveler-icon.vue?vue&type=template&id=815d8f80&scoped=true"
import script from "./traveler-icon.vue?vue&type=script&lang=js"
export * from "./traveler-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815d8f80",
  null
  
)

export default component.exports